export default "__VITE_ASSET__DQHsQUP7__"